import round from "./round";
import WINDOW from "./window";

/**
 * Set pointer "x" and "y" position
 * @param {PointerEvent | TouchEvent} event
 */
const setWindowPointer = (event) => {
  const pointer = /** @type {WindowCoordinatesProps} */ (WINDOW.get("pointer"));
  // const isTouch = event instanceof TouchEvent;
  const isTouch = event.touches;

  const clientX = isTouch ? event.touches[0]?.clientX : event.clientX;
  const clientY = isTouch ? event.touches[0]?.clientY : event.clientY;

  pointer.set("x", round(clientX || 0));
  pointer.set("y", round(clientY || 0));
};

export default setWindowPointer;
